const mapCampaignLinkFormToPayload = (formValues = {}) => ({
  title: formValues.title,
  destinationUrl: formValues.destinationUrl,
  isActive: formValues.isActive,
  owner: formValues.owner,
  channel: formValues.channel,
  format: formValues.format,
  direction: formValues.direction,
  relatedBrandIds: formValues.related_brand_ids ?? [],
  relatedBrandNames: (formValues.related_brands ?? []).map((brand) => brand.name).filter(Boolean),
  relatedCategorySource: formValues.related_category_source ?? null,
  relatedCategoryLevel: formValues.related_category_level ?? null,
  relatedGlobalCategoryId: formValues.related_global_category_id ?? null,
  relatedGlobalCategoryName: formValues.related_global_category_name ?? null,
  relatedOutletGlobalCategoryId: formValues.related_outlet_global_category_id ?? null,
  relatedCategoryPathLabel: formValues.related_category_path_label ?? null,
  relatedGlobalCategoryPath: Array.isArray(formValues.related_global_category_path)
    ? formValues.related_global_category_path.filter(Boolean)
    : [],
  relatedProductFilter: formValues.related_product_filter ?? null,
  relatedProductId: formValues.related_product_id ?? null,
  relatedProductSource: formValues.related_product_source ?? null,
  relatedProductName: formValues.related_product_name ?? null,
  relatedProductBarcode: formValues.related_product_barcode ?? null,
  relatedProductLabel: formValues.related_product_label ?? null,
  relatedPromoId: formValues.related_promo_id ?? null,
  relatedPromoTitle: formValues.related_promo_title ?? null,
  relatedPromoStartDate: formValues.related_promo_start_date ?? null,
  relatedPromoEndDate: formValues.related_promo_end_date ?? null,
  relatedPromoSource: formValues.related_promo_source ?? null,
  campaignDate: formValues.campaign_date ?? null,
})

export default mapCampaignLinkFormToPayload
